/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import {
  ACCOUNT_NAVIGATION,
  ADMIN_ACCOUNT_NAVIGATION,
  BASIC_ACCOUNT_NAVIGATION,
  ROUTES,
  setElementHeights,
  SUPER_ADMIN_ACCOUNT_NAVIGATION,
} from '../../assets/constants/strings';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import HeaderBar from '../../components/HeaderBar';
import $ from 'jquery';
import LeftNavigation from '../../components/Account/LeftNavigation';
import RightNav from '../../components/RightNav';
import Menu from '../../components/Menu';
import FAQModal from '../../components/Modals/FAQ';
// import PaymentSettings from '../../components/MyAccount/Payments';
import './style.scoped.scss';
// import Transactions from '../../components/MyAccount/Transactions';
import AccountInfo from '../../components/MyAccount/AccountInfo';
import MembershipInfo from '../../components/MyAccount/Membership';
// import Users from '../../components/MyAccount/Users';
import ReactGA from 'react-ga';
import UsageStatus from '../../components/MyAccount/Usage';

const MyAccountPage = ({
  user,
  cards,
  // transactions,
  usersByClient,
  // getTransactions,
  // getUsersByClientId,
  userLoading,
  paddleLoading,
  paymentMethod,
}) => {
  const { page } = useParams();

  const [selectedPage, setSelectedPage] = useState(page);

  const [isRightNavVisible, setIsRightNavVisible] = useState(
    window.innerWidth > 950
  );
  const [FAQuestion, setFAQuestion] = useState(0);

  useEffect(() => {
    $(window).on('resize', setElementHeights);

    // Google Analytics uncomment next line to enable
    ReactGA.initialize('UA-188442605-15');
    ReactGA.set({ userId: user.userID });
  }, []);

  // useEffect(() => {
  //   if (
  //     (!cards && user.isCorporate && user.isAdmin) ||
  //     (!cards && user && user.accountType === 'individual' && user.isActive)
  //   )
  //     getCards();
  //   // if (
  //   //   (!transactions && user.isCorporate && user.isAdmin) ||
  //   //   (!transactions &&
  //   //     user &&
  //   //     user.accountType === 'individual' &&
  //   //     user.isActive)
  //   // )
  //   //   getTransactions();
  //   // if (
  //   //   user &&
  //   //   user.isActive &&
  //   //   user.isAdmin &&
  //   //   (!usersByClient || usersByClient === null)
  //   // )
  //   //   getUsersByClientId();
  // }, [cards, usersByClient]);

  useEffect(() => {
    definePageTitle();
    setElementHeights();

    ReactGA.pageview(window.location.pathname);
  });

  const handleRightNav = (visible) => {
    setIsRightNavVisible(visible);
  };

  const handleSetFAQ = (question) => {
    setFAQuestion(question);
    $('#FAQModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const definePageTitle = () => {
    // need to ensure we can match to one of the pages
    let accountType = user.isSuperAdmin
      ? SUPER_ADMIN_ACCOUNT_NAVIGATION
      : user.isCorporate && user.isAdmin
      ? ADMIN_ACCOUNT_NAVIGATION
      : user.isCorporate && user.isBasic
      ? BASIC_ACCOUNT_NAVIGATION
      : ACCOUNT_NAVIGATION;
    if (
      page &&
      Object.values(accountType).filter((item) => item.URL === page).length > 0
    ) {
      setSelectedPage(page);
      document.title =
        Object.values(accountType).filter((item) => item.URL === page)[0].NAV +
        ' | RegulationCity';
    } else setSelectedPage(Object.values(accountType)[0].URL);
  };

  if (
    !user ||
    (user && !user.isActive)
    // (user &&
    //   !(user.accountStatus === 'trialing' || user.accountStatus === 'active'))
  ) {
    return <Redirect to={ROUTES.LOGIN} />;
  }

  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <Header />
          <HeaderBar pageTitle='Account Settings' />
        </div>
      </nav>

      <main role='main' className='wf-document px-0 mb-0' id='wf-my-account'>
        <LeftNavigation
          activePage={selectedPage}
          isCorporte={user.isCorporate}
          isAdmin={user.isAdmin}
        />

        {user.isCorporate && user.isAdmin ? (
          <div className='col' id='main-content'>
            {{
              [ADMIN_ACCOUNT_NAVIGATION.INFO.URL]: (
                <AccountInfo isCorporate={user.isCorporate} />
              ),
              // [ADMIN_ACCOUNT_NAVIGATION.PAYMENT.URL]: <PaymentSettings />,
              [ADMIN_ACCOUNT_NAVIGATION.MEMBERSHIP.URL]: (
                <MembershipInfo
                  user={user}
                  usersByClient={usersByClient}
                  loading={userLoading}
                  paddleLoading={paddleLoading}
                  paymentMethod={paymentMethod}
                />
              ),
              // [ADMIN_ACCOUNT_NAVIGATION.TRANSACTION.URL]: <Transactions />,
              [ADMIN_ACCOUNT_NAVIGATION.USAGE.URL]: (
                <UsageStatus userPlan={user.userPlan} />
              ),
              // [ADMIN_ACCOUNT_NAVIGATION.USERS.URL]: <Users />,
            }[selectedPage] || (
              <h1>
                Welcome to your account settings. Please select an item on the
                left navigation to get started.
              </h1>
            )}
          </div>
        ) : user.isCorporate && user.isBasic ? (
          <div className='col' id='main-content'>
            {{
              [BASIC_ACCOUNT_NAVIGATION.INFO.URL]: (
                <AccountInfo isCorporate={user.isCorporate} />
              ),
            }[selectedPage] || (
              <h1>
                Welcome to your account settings. Please select an item on the
                left navigation to get started.
              </h1>
            )}
          </div>
        ) : (
          <div className='col' id='main-content'>
            {{
              [ACCOUNT_NAVIGATION.INFO.URL]: (
                <AccountInfo isCorporate={user.isCorporate} />
              ),
              // [ACCOUNT_NAVIGATION.PAYMENT.URL]: <PaymentSettings />,
              [ACCOUNT_NAVIGATION.MEMBERSHIP.URL]: (
                <MembershipInfo
                  user={user}
                  loading={userLoading}
                  paddleLoading={paddleLoading}
                  paymentMethod={paymentMethod}
                />
              ),
              // [ACCOUNT_NAVIGATION.TRANSACTION.URL]: <Transactions />,
              [ADMIN_ACCOUNT_NAVIGATION.USAGE.URL]: (
                <UsageStatus user={user} />
              ),
            }[selectedPage] || (
              <h1>
                Welcome to your account settings. Please select an item on the
                left navigation to get started.
              </h1>
            )}
          </div>
        )}

        <RightNav
          accountPage
          handleVisibility={handleRightNav}
          handleSetFAQ={handleSetFAQ}
        />

        {!isRightNavVisible && <Menu accountPage handleSetFAQ={handleSetFAQ} />}
      </main>
      <Footer isDocument isCentered isAbsolute showLogo />
      <FAQModal question={FAQuestion} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  cards: state.user.cards,
  // transactions: state.user.transactions,
  usersByClient: state.user.usersByClient,
  userLoading: state.user.loading,
  paddleLoading: state.paddle.loading,
  paymentMethod: state.paddle.paymentMethod,
});

const mapDispatchToProps = {
  // getTransactions,
  // getUsersByClientId,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountPage);
